import React, { Component } from "react";
import Draggable from "react-draggable";
import { withRouter } from "react-router-dom";

class ConfirmationModal extends Component {
    render() {
        const { heading, paragraph, onOk, onCancel, loading, btnLabel = "Ok",cancelBtnLabel="Cancel" } = this.props;

        return (
            <React.Fragment>
                <div
                    id="modalId"
                    className="modal modal-region deleteModal"
                    style={{ display: "block" }}
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <Draggable handle=".draggable" cancel=".ignore-drag">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button
                                        type="button"
                                        className="close ignore-drag"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={() => onCancel()}
                                    >
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="" />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body region-otr p-3 pb-5 draggable">
                                    <div className="deleteInner">
                                        <i className="far fa-check-circle" />
                                        <h2 className="ignore-drag cursor-notallowed">{heading}</h2>
                                        <p className="ignore-drag cursor-notallowed">{paragraph}</p>
                                    </div>

                                    <div className="btnOtr">
                                        <button type="button" className="btn btn-secondary btnClr" onClick={() => onCancel()}>
                                            {cancelBtnLabel || "Cancel"}
                                        </button>
                                        <button disabled={loading} type="button" className="btn btn-primary btnRgion" onClick={() => onOk()}>
                                            {loading ? (
                                                <div className="spinner-border spinner-border-sm text-white" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            ) : (
                                                btnLabel || "OK"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(ConfirmationModal);
